import type { WorkflowRunStageOut } from '@/services/workflows2';

interface PayloadPanelProps {
  stage: WorkflowRunStageOut;
  isStaff: boolean;
}

export function PayloadPanel({ stage, isStaff }: PayloadPanelProps) {
  const isCodeNode = !stage.model_pedido;

  const renderField = (label: string, value: string | null | undefined, restricted: boolean) => {
    if (value)
      return (
        <div style={{ marginBottom: '8px', color: 'var(--text-1)' }}>
          <strong>{label}:</strong>{' '}
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              margin: '4px 0',
              padding: '8px',
              background: 'var(--bg-2)',
              border: '1px solid var(--border-2)',
              color: 'var(--text-2)',
            }}
          >
            {value}
          </pre>
        </div>
      );
    if (restricted && !isStaff)
      return (
        <div style={{ marginBottom: '8px', color: 'var(--text-3)' }}>
          <strong>{label}:</strong> restrito
        </div>
      );
    return null;
  };

  return (
    <div className="payload-panel">
      {renderField('System Base', stage.system_base, true)}
      {renderField('System Enviado', stage.system_enviado, true)}
      {renderField('User Enviado', stage.user_enviado, true)}

      {isCodeNode ? (
        <div
          style={{
            padding: '8px',
            background: 'var(--sig-info-bg)',
            color: 'var(--sig-info-text)',
            margin: '8px 0',
            border: '1px solid var(--sig-info-border)',
          }}
        >
          nó determinístico — sem chamada de modelo
        </div>
      ) : (
        <div
          style={{
            padding: '8px',
            background: 'var(--sig-ok-bg)',
            border: '1px solid var(--sig-ok-border)',
            color: 'var(--sig-ok-text)',
            margin: '8px 0',
          }}
        >
          <div>
            <strong>Model:</strong> {stage.model_respondido || stage.model_pedido}
          </div>
          <div>
            <strong>Tokens:</strong> In: {stage.tokens_in} / Out: {stage.tokens_out} / Cached:{' '}
            {stage.tokens_cached}
          </div>
          <div>
            <strong>Custo USD:</strong> {stage.custo_usd}
          </div>
          <div>
            <strong>Duração (ms):</strong> {stage.duracao_ms}
          </div>
        </div>
      )}

      {stage.saida_texto && (
        <div style={{ marginTop: '16px', color: 'var(--text-1)' }}>
          <strong>Saída Texto:</strong>
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              padding: '8px',
              background: 'var(--bg-2)',
              border: '1px solid var(--border-2)',
              color: 'var(--text-2)',
            }}
          >
            {stage.saida_texto}
          </pre>
        </div>
      )}
      {stage.saida_estruturada && (
        <div style={{ marginTop: '16px', color: 'var(--text-1)' }}>
          <strong>Saída Estruturada:</strong>
          <pre
            style={{
              padding: '8px',
              background: 'var(--bg-3)',
              color: 'var(--text-1)',
              border: '1px solid var(--border-3)',
              overflowX: 'auto',
            }}
          >
            {JSON.stringify(stage.saida_estruturada, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
